import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
  destroy,
  getParent,
  getRoot,
} from 'mobx-state-tree';
import { globalStore } from 'stores';
import { debug } from 'lib';
import createStore from '../../../lib/create-store';
import { getStore } from './gift';
// import gift from '../gift'

const log = debug.create('giftBottom');
const error = debug.create('giftBottom:error');

const countList = [
  { title: '笑脸', count: 50 },
  { title: '爱心', count: 100 },
  { title: '比翼双飞', count: 300 },
  { title: 'LOVE', count: 520 },
  { title: '流星雨', count: 1314 },
  { title: '生生世世', count: 3344 },
  { title: '长长久久', count: 9999 },
];

const initState = {
  countList: countList,
  currentUser: 1,
  userAll: { uid: 0, name: '全部', check: true },
  // baseUserList
};

const CountModel = types.model('CountModel', {
  title: '',
  count: 0,
});

const UserModel = types
  .model({
    uid: types.identifierNumber,
    name: '',
    index: 0,
    micName: '',
    _check: true,
  })
  .views((self) => {
    return {
      // 是否可用（被选中）
      get enable() {
        let { userInfo } = globalStore;
        let { currentGift } = getStore();

        // let currentGift = gift.getGift(currentGiftId)
        let root = getRoot(self);

        if (
          currentGift &&
          // && currentGift.id === 1080
          !currentGift.oneself &&
          root.hasMe && // 列表中没有我自己的话，即全部都可以选中
          ((userInfo && userInfo._id === self.uid) || // 我自己
            self.uid === 0) // 全部
        ) {
          return false;
        }
        return true;
      },
      get check() {
        if (self.enable) {
          return self._check;
        }
        return false;
      },
    };
  })
  .actions((self) => {
    const remove = (user) => {
      getParent(self, 2).removeUser(self);
    };
    const setCheck = (status) => {
      self._check = status;
    };
    const setMicUser = (micUser) => {
      self.micUser = micUser;
    };
    return {
      remove,
      setCheck,
      setMicUser,
    };
  });

// reaction(() => globalStore.isLogin,(isLogin) => {
//   console.log('isLogin============',isLogin)
// })

export const Model = types
  .model('GiftBottom', {
    countList: types.array(CountModel),
    count: '1',
    userList: types.array(UserModel),
    userAll: UserModel,
    baseUserList: types.array(UserModel),
    currentUser: types.safeReference(UserModel),
    isMarquee: true, // 是否上跑道
    enableMultipleSelect: false, // 是否支持多选
  })
  .views((self) => {
    return {
      get allUserList() {
        let { userInfo } = globalStore;
        return (self.enableMultipleSelect ? [self.userAll] : []).concat(
          ...self.userList,
        );
        // .filter((item) => {
        //   if (userInfo) {
        //     return item.uid !== userInfo._id
        //   }
        //   return true;
        // })
      },
      get checkUserList() {
        // let { userInfo } = globalStore;
        return self.userList.filter((item) => item.check);
        // .filter((item) => {
        // if (userInfo) {
        //   return item.uid !== userInfo._id
        // }
        // return true;
        // })
      },
      get checkNames() {
        if (self.userAll.check && self.enableMultipleSelect) {
          return self.userAll.name;
        }
        return self.checkUserList
          .map((item) => {
            return item.micName || item.name;
          })
          .join(',');
      },
      get checkIds() {
        return self.checkUserList.map((item) => item.uid).join(',');
      },
      get hasMe() {
        let { userInfo } = globalStore;
        if (userInfo) {
          return self.userList.some((item) => item.uid === userInfo._id);
        }
        return false;
      },
    };
  })
  .actions((self) => {
    const setCount = (count) => {
      self.count = count + '';
    };
    const resetOther = () => {
      if (!self.enableMultipleSelect) {
        self.userList.forEach((item) => {
          item._check = false;
        });
      }
    };
    const addUser = (user) => {
      resetOther();
      const userRes = hasUser(user);
      if (!userRes) {
        self.userList.push(user);
      } else {
        userRes.setCheck(true);
      }
      if (self.userList.length === 1) {
        self.currentUser = user.id;
      }
    };
    const hasUser = (user) => {
      return self.userList.find((item) => user.uid === item.uid);
    };
    const updateUserList = (list) => {
      log('updateUserList', list);
      self.userList = list
        .map((user) => {
          let oldUser = self.userList.find((item) => {
            return user.uid === item.uid;
          });
          if (oldUser) {
            log('updateUserList oldUser check', oldUser.check);
            user._check = oldUser.check;
          }
          return user;
        })
        .sort((a, b) => {
          return a.index - b.index;
        });
    };
    // const selectUser = (id) => {
    //   self.currentUser = id;
    // }
    const selectAll = (status) => {
      self.userList.forEach((item) => {
        item._check = status;
      });
      let allCheck = self.userList.every((item) => item.check);
      self.userAll.setCheck(allCheck);
    };

    const selectUser = (user, status) => {
      resetOther();
      user.setCheck(status);
      if (user.uid) {
        let allCheck = self.userList.every((item) => item.check);
        self.userAll.setCheck(allCheck);
      } else {
        // uid===0  选择全部
        selectAll(status);
      }
    };

    const setMarquee = (status) => {
      self.isMarquee = status;
    };

    const getUser = (uid) => {
      return self.userList.find((item) => {
        return item.uid === uid;
      });
    };

    const setEnableMultipleSelect = (status) => {
      self.enableMultipleSelect = status;
    };

    return {
      setCount,
      addUser,
      selectUser,
      setMarquee,
      getUser,
      updateUserList,
      selectAll,
      setEnableMultipleSelect,
    };
  });

// export default {
//   initState,
//   Model
// };

let { store, Provider, useStore } = createStore(Model, initState);

export { store, Provider, useStore };
